/**
 * Timeout Constants
 * All timeout values in milliseconds
 */

export const TIMEOUTS = {
  API_REQUEST: 5000,            // 5 seconds for API requests
  REFRESH_TOKEN: 5000,          // 5 seconds for token refresh
  EXECUTION_REFRESH_DELAY: 1000 // 1 second delay after workflow execution
} as const;
